import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { debounce } from 'utils/common';
import {  useSelector } from 'react-redux';
import {toTitleCase} from "utils/common"

export default function useDocumentFilter(pageSettings , setPageSettings) {
    const [searchParams, setSearchParams] = useSearchParams();
    const {
        userData, userDataLoading,     
        documentSubType, documentSubTypeLoading,
        costCenter, costCenterLoading
        
    } = useSelector((state) => state.common);

    const [filterLoading, setFilterLoading] = useState(false)
  const [filters, setFilters] = useState([
    {
        key: "search",
        label: "Search term",
        value: searchParams.get("search") || ""
    },    
    {
        key: "issue_date_before",
        label: "Issued Before",
        value: searchParams.get("issue_date_before") || ""
    },
    {
        key: "issue_date_after",
        label: "Issued After",
        value: searchParams.get("issue_date_after") || ""
    },
    {
        key: "expiry_date_before",
        label: "Expiry Before",
        value: searchParams.get("expiry_date_before") || ""
    },
    {
        key: "expiry_date_after",
        label: "Expiry After",
        value: searchParams.get("expiry_date_after") || ""
    },
    {
        key: "document_type",
        label: toTitleCase(searchParams.get("document_type") || ""),
        value: searchParams.get("document_type") || ""
    },
    // {
    //     key: "document_sub_type",
    //     label: searchParams.get("document_sub_type") || "",
    //     value: searchParams.get("document_sub_type") || ""
    // },
    {
        key: "company_user",
        label: searchParams.get("company_user") || "",
        value: searchParams.get("company_user") || ""
    },
    {
        key: "cost_center",
        label: searchParams.get("cost_center") || "",
        value: searchParams.get("cost_center") || ""
    }
  ]);

  useEffect(()=>{

    if(!documentSubTypeLoading && !userDataLoading){
      
        console.log(searchParams, "------searchParams")
     
        let selectedDocumentType = searchParams.get("documentType") || ""
        let selectedUserData = [...userData].find(item=>item.id == searchParams.get("company_user") || "")
        let selectedDocumentSubType = [...documentSubType].find(item=>item.id == searchParams.get("documentSubType") || "")
        let selectedCostCenter = [...costCenter].find(item=>item.id == searchParams.get("cost_center") || "")
    
        let _filters = [
            {
                key: "search",
                label: "Search term",
                value: searchParams.get("search") || ""
            },
            {
                key: "issue_date_after",
                label: "Issued After",
                value: searchParams.get("issue_date_after") || ""
            },
            {
                key: "issue_date_before",
                label: "Issued before",
                value: searchParams.get("issue_date_before") || ""
            },
            {
                key: "expiry_date_after",
                label: "Expiry After",
                value: searchParams.get("expiry_date_after") || ""
            },
            {
                key: "expiry_date_before",
                label: "Expiry before",
                value: searchParams.get("expiry_date_before") || ""
            },
            {
                key: "document_type",
                 label: selectedDocumentType?.name,
                value: searchParams.get("document_type") || ""
            },
            {
                key: "document_sub_type",
                 label: selectedDocumentSubType?.name,
                value: searchParams.get("document_sub_type") || ""
            },
            {
                key: "company_user",
                 label: selectedUserData?.first_name+" "+selectedUserData?.last_name,
                value: searchParams.get("company_user") || ""
            },
            {
                key: "cost_center",
                label: selectedCostCenter?.name,
                value: searchParams.get("cost_center") || ""
            }
          ]
          setFilters(_filters)
    }

 
  },[
    userData,   
    documentSubType,
    costCenter
  ])

  const handleFilterChange =  (data, key, make_call=false) => {
    console.log( "AAAA", data)

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
   
    selectedFilter['label'] = data?.label || ""
    selectedFilter['value'] = data?.value || ""
    setFilters(_filters)
    console.log(_filters, "-----filtersssss")
    console.log( _filters, "AAAA")
    if(make_call){
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }


    
  };
  const handleInputChange = debounce((data, key, make_call=false) => {
    console.log( "FFFF")

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){

        
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }

  }, 1000)

  const handleDateChange = (data, key, make_call=false) => {

    
    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){

        
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }

  }

  return {
    handleFilterChange,
    filters,
    handleInputChange,
    filterLoading, setFilterLoading,
    handleDateChange
  };
}
